import React from "react";
import { Button } from "../../../components/ui/button";
import { EditorQuickFiltersState } from "../utils/editorPresentationUtils";

interface EditorQuickFiltersProps {
  value: EditorQuickFiltersState;
  onChange: (next: EditorQuickFiltersState) => void;
}

const EditorQuickFilters = ({ value, onChange }: EditorQuickFiltersProps) => {
  const toggle = (key: keyof EditorQuickFiltersState) => {
    onChange({ ...value, [key]: !value[key] });
  };

  return (
    <div className="flex flex-wrap gap-2">
      <Button
        size="sm"
        variant={value.showOnlyChanged ? "default" : "outline"}
        onClick={() => toggle("showOnlyChanged")}
      >
        Changed
      </Button>
      <Button
        size="sm"
        variant={value.showEmpty ? "default" : "outline"}
        onClick={() => toggle("showEmpty")}
      >
        Empty
      </Button>
      <Button
        size="sm"
        variant={value.showMissing ? "default" : "outline"}
        onClick={() => toggle("showMissing")}
      >
        Missing
      </Button>
      <Button
        size="sm"
        variant={value.compact ? "default" : "outline"}
        onClick={() => toggle("compact")}
      >
        Compact
      </Button>
    </div>
  );
};

export default EditorQuickFilters;
